import request from "@/utils/request";

export function getSubscriptions(page = 10)
{
    return request({
        url: "/subscriptions",
        method: "get",
        params: {
            page: page
        },
        showLoader: true,
        withoutErrorMessages: true
    });
}

export function cancelSubscription(subscription_id)
{
    return request({
        url: "/subscriptions/" + subscription_id,
        method: "delete"
    });
}
